import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { RefundFormValues } from 'components/Dialogs/Finance/RefundDialog/RefundSchema';

export interface RefundAllocation {
  charge_id: string;
  amount: number;
}

export interface Refund extends RefundFormValues {
  id: string;
}

export type CreateRefundResult = Refund | null;
export type CreateRefundParams = RefundFormValues;

async function createRefund(params: CreateRefundParams): Promise<CreateRefundResult> {
  // make api call
  const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/finance/refunds`, params);

  // return the data object
  return result.data as Refund | null;
}

const useCreateRefund = createMutation<CreateRefundResult, CreateRefundParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: CreateRefundParams) => createRefund(variables),
});

export { createRefund as CreateRefund, useCreateRefund };
